import { useEffect, useState } from 'react';

// Pantalla de móvil: menos de 768 px de ancho, el mismo corte que el
// breakpoint `md` de Tailwind. Se actualiza al girar el móvil o cambiar el
// tamaño de la ventana. Sin `window` (pruebas) devuelve false.
const CONSULTA_MOVIL = '(max-width: 767px)';

const leerEsMovil = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  try {
    return window.matchMedia(CONSULTA_MOVIL).matches;
  } catch (_) {
    return false;
  }
};

export default function useEsMovil() {
  const [esMovil, setEsMovil] = useState(leerEsMovil);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const consulta = window.matchMedia(CONSULTA_MOVIL);
    const alCambiar = () => setEsMovil(consulta.matches);
    alCambiar();
    // Safari antiguo solo tiene addListener/removeListener
    if (typeof consulta.addEventListener === 'function') {
      consulta.addEventListener('change', alCambiar);
      return () => consulta.removeEventListener('change', alCambiar);
    }
    consulta.addListener(alCambiar);
    return () => consulta.removeListener(alCambiar);
  }, []);

  return esMovil;
}
